import {
	WINE_LIST_REQUEST,
	WINE_LIST_SUCCESS,
	WINE_LIST_FAILURE,
	WINE_LATEST_ACTIVITY_REQUEST,
	WINE_LATEST_ACTIVITY_SUCCESS,
	WINE_LATEST_ACTIVITY_FAILURE,
	GET_WINE_DATA_REQUEST,
	GET_WINE_DATA_SUCCESS,
	GET_WINE_DATA_FAILURE,
	UPDATE_CW_WINE_NOTE_REQUEST,
	UPDATE_CW_WINE_NOTE_SUCCESS,
	UPDATE_CW_WINE_NOTE_FAILURE,
	CELLAR_STATS_REQUEST,
	CELLAR_STATS_SUCCESS,
	CELLAR_STATS_FAILURE,
	WINE_RESERVATION_REQUEST,
	WINE_RESERVATION_SUCCESS,
	WINE_RESERVATION_FAILURE,
	UPDATE_WINE_INFO_REQUEST,
	UPDATE_WINE_INFO_SUCCESS,
	UPDATE_WINE_INFO_FAILURE,
	CLEAN_WINE_RESERVATION_STATUS,
} from '../actions/wines'
import { fromJS } from 'immutable';

const initState = {
	createReservationSucc: false,
	list: [],
	wineDataMap: fromJS({}),
	memberWineNoteMap: fromJS({}),
}

export default (state = initState, action) => {
	switch (action.type) {
		case WINE_LIST_REQUEST:
			return {
				...state,
				isLoading: true,
				list: initState.list,
				wineListTotalPage: initState.wineListTotalPage,
			}
		case WINE_LIST_SUCCESS: {
			return {
				...state,
				isLoading: false,
				list: action.payload.wines,
				wineListTotalPage: action.payload.totalPage
			}
		}
		case WINE_LIST_FAILURE: {
			return {
				...state,
				isLoading: false
			}
		}
		case GET_WINE_DATA_REQUEST:
			return {
				...state,
				isLoading: true
			}
		case GET_WINE_DATA_SUCCESS: {
			const wineData = action.payload[0]
			// let wineIndex = state.list.findIndex(item => item.id === wineData.id)
			// const updater = {
			// 	...state.list[wineIndex],
			// 	...wineData,
			// }
			// state.list[wineIndex] = updater
			return {
				...state,
				isLoading: false,
				wineDataMap: state.wineDataMap.set(wineData.id, fromJS(wineData))
			}
		}
		case GET_WINE_DATA_FAILURE: {
			return {
				...state,
				isLoading: false
			}
		}
		case UPDATE_CW_WINE_NOTE_REQUEST:
			return {
				...state,
				isLoading: true
			}
		case UPDATE_CW_WINE_NOTE_SUCCESS: {
			return {
				...state,
				isLoading: false,
				summary: { ...action.payload }
			}
		}
		case UPDATE_CW_WINE_NOTE_FAILURE: {
			return {
				...state,
				isLoading: false
			}
		}
		case CELLAR_STATS_REQUEST:
			return {
				...state,
				isLoading: true,
			}
		case CELLAR_STATS_SUCCESS: {
			return {
				...state,
				isLoading: false,
				summary: { ...action.payload }
			}
		}
		case CELLAR_STATS_FAILURE: {
			return {
				...state,
				isLoading: false
			}
		}
		case WINE_RESERVATION_REQUEST:
			return {
				...state,
				isLoading: true,
				createReservationSucc: false,
			}
		case WINE_RESERVATION_SUCCESS: {
			return {
				...state,
				isLoading: false,
				createReservationSucc: true,
			}
		}
		case WINE_RESERVATION_FAILURE: {
			return {
				...state,
				isLoading: false
			}
		}
		case CLEAN_WINE_RESERVATION_STATUS: {
			return {
				...state,
				createReservationSucc: false,
			}
		}
		case UPDATE_WINE_INFO_REQUEST:
			return {
				...state,
				isLoading: true
			}
		case UPDATE_WINE_INFO_SUCCESS: {
			return {
				...state,
				isLoading: false,
			}
		}
		case UPDATE_WINE_INFO_FAILURE: {
			return {
				...state,
				isLoading: false
			}
		}
		case WINE_LATEST_ACTIVITY_SUCCESS : {
			return {
				...state,
				memberWineNoteMap: state.memberWineNoteMap.merge(action.payload)
			}
		}
		default:
			return state
	}
}
